import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor() { }
  isLoggedIn(){
    let authid = sessionStorage.getItem("KrCGei");
    let token = sessionStorage.getItem("ZhJtE"+authid);
    let access = true;
    if(token) {
      access = true;
    } else {
       access = false
    }
    return access;
  }
}
